export const PAYROLL_REPORT_LOAD = 'PAYROLL_REPORT_LOAD'
export const PAYROLL_REPORT_LOAD_PENDING = 'PAYROLL_REPORT_LOAD_PENDING'
export const PAYROLL_REPORT_LOAD_FULFILLED = 'PAYROLL_REPORT_LOAD_FULFILLED'
export const PAYROLL_REPORT_LOAD_REJECTED = 'PAYROLL_REPORT_LOAD_REJECTED'

export const PAYROLL_REPORT_DOWNLOAD = 'PAYROLL_REPORT_DOWNLOAD'
export const PAYROLL_REPORT_DOWNLOAD_FULFILLED = 'PAYROLL_REPORT_DOWNLOAD_FULFILLED'

export const PAYROLL_REPORT_SHARE = 'PAYROLL_REPORT_SHARE'
export const PAYROLL_REPORT_SHARE_PENDING = 'PAYROLL_REPORT_SHARE_PENDING'
export const PAYROLL_REPORT_SHARE_FULFILLED = 'PAYROLL_REPORT_SHARE_FULFILLED'
export const PAYROLL_REPORT_SHARE_REJECTED = 'PAYROLL_REPORT_SHARE_REJECTED'

export const PAYROLL_REDRAFT = 'PAYROLL_REDRAFT'
export const PAYROLL_REDRAFT_PENDING = 'PAYROLL_REDRAFT_PENDING'
export const PAYROLL_REDRAFT_FULFILLED = 'PAYROLL_REDRAFT_FULFILLED'
export const PAYROLL_REDRAFT_REJECTED = 'PAYROLL_REDRAFT_REJECTED'

export const SET_FILTERS_PAYROLL = 'SET_FILTERS_PAYROLL'
export const CLEAR_FILTERS_PAYROLL = 'CLEAR_FILTERS_PAYROLL'
